export default {
  'Resolution': 'Résolution',
  'Frame rate': "Fréquence d'images",
  'The higher the frame rate, the smoother the animation': "Plus la fréquence d'images est élevée, plus l'animation est fluide.",
}